import {HttpClient} from "../../service/httpClient/HttpClient";

export class ManagerAccessLevelService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getAccessLevelList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `realms/admin/roles`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getPermissionsList(page, size, tagName) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `permissions/realms/admin`,
                {
                    page,
                    size,
                    tagName
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewRole(title,name, permissions) {

        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `realms/admin/roles`,
                {
                    name,
                    title,
                    permissions
                }
            ).then(resolve).catch(reject)
        })


    }

    updateRoleInfo(id, name,title, permissions) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `realms/admin/roles/${id}`,
                {
                    name,
                    title,
                    permissions
                }
            ).then(resolve).catch(reject)
        })
    }

    getRoleInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `realms/admin/roles/${id}`
            ).then(resolve).catch(reject)
        })
    }

    getAccessFilters() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `permissions/tags/realms/admin`,
                {
                    page: 0,
                    size: 50
                }
            ).then(resolve).catch(reject)
        })
    }
}

function renameKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
}